import _extends from "@babel/runtime/helpers/extends";
import { Search as SearchIcon } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { TextField, useTPAComponentsContext } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '../../../../contexts/translation-context';
import { classes, st } from './search.st.css';
export const Search = _ref => {
  let {
    className,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    rtl
  } = useTPAComponentsContext();
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    "data-hook": "country-search",
    className: st(classes.root, {
      rtl
    }, className),
    prefix: /*#__PURE__*/React.createElement(SearchIcon, null),
    placeholder: t('field.phone.country-search-input.placeholder'),
    "aria-label": t('field.phone.country-search-input.aria-label'),
    autoComplete: "off"
  }));
};
//# sourceMappingURL=search.js.map